import { render, staticRenderFns } from "./SilomConnect.vue?vue&type=template&id=63b86afe&scoped=true&"
import script from "./SilomConnect.vue?vue&type=script&lang=js&"
export * from "./SilomConnect.vue?vue&type=script&lang=js&"
import style0 from "./SilomConnect.vue?vue&type=style&index=0&id=63b86afe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b86afe",
  null
  
)

export default component.exports